import { Controller } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { FieldComponentProps } from "./field-shell";

export function CheckboxField({
  field,
  control,
  disabled,
}: FieldComponentProps) {
  if (field.kind !== "checkbox") return null;
  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: f, fieldState }) => (
        <div className="space-y-1.5">
          <div className="flex items-start gap-2.5">
            <Checkbox
              id={f.name}
              checked={!!f.value}
              onCheckedChange={(c) => f.onChange(c === true)}
              disabled={disabled}
              aria-invalid={!!fieldState.error}
            />
            <Label htmlFor={f.name} className="cursor-pointer leading-snug">
              {field.label}
              {field.required ? (
                <span className="ml-0.5 text-destructive">*</span>
              ) : null}
            </Label>
          </div>
          {field.helpText ? (
            <p className="ml-7 text-[0.8rem] text-muted-foreground">
              {field.helpText}
            </p>
          ) : null}
          {fieldState.error?.message ? (
            <p className="ml-7 text-[0.8rem] font-medium text-destructive">
              {fieldState.error.message}
            </p>
          ) : null}
        </div>
      )}
    />
  );
}
